import {store} from "../store";

export const t = (key, ...values) => {
    let value = store.translations[key];

    if (!value) {
        return key;
    }

    for (let i = 0; i < values.length; i++) {
        value = value.split('{' + i + '}').join(values[i]);
    }

    return value.toUpperCase();
}

export const TKeys = {
    SESSION_EXPIRED: "SESSION_EXPIRED",
    BALANCE: "BALANCE",
    BET: "BET",
    WIN: "WIN",
    HISTORY: "HISTORY",
    TURBO_SPIN: "TURBO_SPIN",
    BET_SETTINGS: "BET_SETTINGS",
    BUY_FREE_SPINS: "BUY_FREE_SPINS",
    PAY_TABLE: "PAY_TABLE",
    PAY_LINE_AND_RULES: "PAY_LINE_AND_RULES",
    WILD_DESCRIPTION: "WILD_DESCRIPTION",
    WILD_2X_DESCRIPTION: "WILD_2X_DESCRIPTION",
    WILD_3X_DESCRIPTION: "WILD_3X_DESCRIPTION",
    SCATTER_DESCRIPTION: "SCATTER_DESCRIPTION",
    GAME_DESCRIPTION: "GAME_DESCRIPTION",
    BET_NOT_ACCEPTED: "BET_NOT_ACCEPTED",
    YOU_WON: "YOU_WON",
    FREE_SPIN: "FREE_SPIN",
    FREE_SPINS_LEFT: "FREE_SPINS_LEFT",
    CLICK_ANYWHERE_FOR_CONTINUE: "CLICK_ANYWHERE_FOR_CONTINUE",
    RECONNECTING: "RECONNECTING",
    CONNECTION_LOST: "CONNECTION_LOST",
    YOU_WON_FREE_SPIN: "YOU_WON_FREE_SPIN",
    INSUFFICIENT_FUNDS: "INSUFFICIENT_FUNDS",
    MULTIPLIER: "MULTIPLIER",
    PAY_TABLE_DESCRIPTION: "PAY_TABLE_DESCRIPTION",
    TUMBLE_FEATURE: "TUMBLE_FEATURE",
    TUMBLE_FEATURE_DESCRIPTION: "TUMBLE_FEATURE_DESCRIPTION",
    FREE_SPINS_RULES: "FREE_SPINS_RULES",
    FREE_SPINS_RULES_DESCRIPTION: "FREE_SPINS_RULES_DESCRIPTION",
    MULTIPLIER_SYMBOL_DESCRIPTION: "MULTIPLIER_SYMBOL_DESCRIPTION",
    GAME_LIMITS: "GAME_LIMITS",
    RTP: "RTP",
    MIN_BET: "MIN_BET",
    MAX_BET: "MAX_BET",
    MAX_ODD: "MAX_ODD",
    MAX_WIN: "MAX_WIN",
    TOTAL: "TOTAL",
    FREE_BETS_LEFT: "FREE_BETS_LEFT",
    LAST_FREE_BET: "LAST_FREE_BET",
};

